export default {
  'CheckboxCell.Selector': async ({ data, showCheckboxes }, outlet, internalStateSetter) => {
    if (showCheckboxes) return;
    outlet({ action: 'changeData', payload: data?.data === 'true' ? 'false' : 'true' });
    internalStateSetter({ data: { ...data, data: data?.data === 'true' ? 'false' : 'true' } })
  },
}